import { Text } from '@fluentui/react-components';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SubstitutionCard } from './SubstitutionCard';
import './SubstitutionDaySection.scss';
import { SubstitutionDay } from './SubstitutionWidget.interface';

export interface SubstitutionDaySectionProps {
  day: SubstitutionDay;
}

export const SubstitutionDaySection: FC<SubstitutionDaySectionProps> = ({ day }) => {
  const { t } = useTranslation();

  return (
    <div className="substitutionDaySection">
      <Text className="substitutionDaySection__header" weight="bold" size={400} block={true}>
        {day.label}
      </Text>

      <div className="substitutionDaySection__entries">
        {day.entries.map((entry) => (
          <div key={entry.id} className="flex gap-4">
            <div className="flex flex-col substitutionDaySection__time">
              <Text className="substitutionDaySection__period" weight="semibold" size={300}>
                {t('dashboard:substitution:period', {
                  defaultValue: '{{period}}.Stunde',
                  period: entry.period,
                })}
              </Text>
              <Text className="substitutionDaySection__timeRange" size={200}>
                {entry.startTime} - {entry.endTime}
              </Text>
            </div>
            <div className="flex-1">
              <SubstitutionCard entry={entry} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
